/**
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
import dynamic from 'next/dynamic';
import { ComponentProps } from 'react';

import { Button as SpButton } from './index.js';
import { ClearButton as SpClearButton } from './index.js';
import { CloseButton as SpCloseButton } from './index.js';

export const Button = dynamic<
  JSX.LibraryManagedAttributes<typeof SpButton, ComponentProps<typeof SpButton>>
>(() => import('./index.js').then(({ Button }) => Button), { ssr: false });
export const ClearButton = dynamic<
  JSX.LibraryManagedAttributes<
    typeof SpClearButton,
    ComponentProps<typeof SpClearButton>
  >
>(() => import('./index.js').then(({ ClearButton }) => ClearButton), {
  ssr: false,
});
export const CloseButton = dynamic<
  JSX.LibraryManagedAttributes<
    typeof SpCloseButton,
    ComponentProps<typeof SpCloseButton>
  >
>(() => import('./index.js').then(({ CloseButton }) => CloseButton), {
  ssr: false,
});
